<template>
  <div class="text-image text-image–-secondary" v-if="config">
    <div class="text-image__visual">
      <img class="text-image__item lazyloaded" :alt="config.alt || (config.on_text ? config.on_text.title : config.description)" :src="config.src">
      <a href="javascript:void(0);" @click="actionHandler(config.action)" class="text-image__visual-title">
        <div class="text-image__visual-title--uppercase">{{config.on_text.title}}</div>
        {{config.on_text.desc}}
      </a>
    </div>
    <div class="text-image__content start-xs">
      <div class="text-image__text">
        <div class="text-image__description" style="color:#575757">{{config.description}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import actionMixins from "@/utils/action.mixins";

export default {
  name: "SimpleItem",
  mixins: [actionMixins],
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .text-image { display: block; text-decoration: none; }
  .text-image–-secondary, .text-image–-secondary .text-image__visual { position: relative; }
  .text-image–-secondary .text-image__visual .text-image__item { width: 100%; height: auto; }
  .text-image–-secondary .text-image__visual-title {
    font-size: 1.25rem; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; color: #fff; text-align: center; line-height: 1; text-decoration: none;
    width: 100%; height: 100%; position: absolute; top: 0; z-index: 1; display: flex; justify-content: center; align-items: center; flex-direction: column;
  }
  .text-image–-secondary .text-image__visual-title:before { content: ""; width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 1; }
  .text-image–-secondary .text-image__visual-title--uppercase {
    font-size: 1.875rem; font-family: HelveticaNeueLTW05-75Bold,arial,sans-serif; letter-spacing: -.05rem; display: block;
  }
  .text-image–-secondary .text-image__content { display: flex; }
  .text-image–-secondary .text-image__content .text-image__text { flex-grow: 1; width: 0; text-align: left; }
  .text-image–-secondary .text-image__description {
    font-size: .875rem; font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; color: #575757; padding-top: .3125rem; // max-width: 24.375rem; 
  }
  @media screen and (min-width: 48em) {
    .text-image–-secondary .text-image__visual-title { font-size: 2.5rem; }
    .text-image–-secondary .text-image__visual-title--uppercase { font-size: 3.75rem; letter-spacing: -.075rem }
  }
  @media screen and (min-width: 64em) {
    .text-image–-secondary .text-image__visual:after {
      content: ""; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: transparent; transition: background .5s ease-in-out;
    }
    .text-image–-secondary .text-image__visual:hover:after {
      background: rgba(0,0,0,.4);
    }
    .text-image–-secondary .text-image__description { margin-top: .625rem; }
  }
</style>